// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__3uwT4","spinnerImage":"LoadingSpinner_spinnerImage__1lMv2"};